export default __webpack_public_path__ + "static/media/dessert.caca0423.svg";